var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMagicWand = function SvgMagicWand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54.167 58.334-12.5-12.5m20.876-31.25v-6.25m16.414 12.752 4.42-4.42m-4.42 37.5 4.42 4.42m-37.5-37.5-4.42-4.42M85.46 37.5h6.25M25.548 86.953l38.488-38.489c1.65-1.65 2.475-2.475 2.784-3.426a4.167 4.167 0 0 0 0-2.575c-.309-.952-1.134-1.777-2.784-3.427l-3.072-3.072c-1.65-1.65-2.475-2.475-3.426-2.784a4.167 4.167 0 0 0-2.575 0c-.952.31-1.777 1.134-3.427 2.784L13.047 74.453c-1.65 1.65-2.475 2.475-2.784 3.426a4.166 4.166 0 0 0 0 2.575c.31.952 1.134 1.777 2.784 3.427l3.072 3.072c1.65 1.65 2.476 2.475 3.427 2.784a4.167 4.167 0 0 0 2.575 0c.951-.31 1.776-1.134 3.427-2.784Z",
    stroke: "#000",
    strokeWidth: 8.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgMagicWand;